import(/* webpackMode: "eager" */ "/app/src/app/[lang]/(guest)/(blank)/(account)/login/page.jsx");
